/**
 * セールステータスに応じて要素の表示を制御
 * 計算結果を data 属性とクラスとして設定
 * 動的に追加される <product-card-link> にも対応（MutationObserver 使用）
 */
(() => {
  const badgeTextMap = {
    preSale: 'Coming soon',
    postSale: '販売終了'
  };

  function deleteAddToCart (link) {
    const atcc =  link.querySelector('quick-add-component');
    if(atcc) atcc.remove();
  }

  // 1つの product-card-link に対してバッジ処理を行う関数
  function initProductCardLink(link) {
    // すでに処理済みなら何もしない（重複防止）
    if (link.dataset.saleBadgeInitialized === 'true') return;
    link.dataset.saleBadgeInitialized = 'true';

    const status = getSaleTimeStatus(link);

    if (!status) return;

    link.setAttribute('data-sale-status', status);
    link.classList.add(`add-${status}`);
    link.classList.add('add-loaded');

    const text = badgeTextMap[status];
    if (text) {
      const badge = document.createElement('span');
      badge.className = 'product-card-link_badge';
      badge.textContent = text;
      link.querySelector('.product-card__content').append(badge);
      // link.append(badge);
      deleteAddToCart(link);
    }
  }

  // ある範囲（root）の中にある全ての <product-card-link> を初期化
  function initAllProductCardLinks(root = document) {
    const productCardLinks = root.querySelectorAll('product-card-link');
    if (!productCardLinks.length) return;

    productCardLinks.forEach((link) => initProductCardLink(link));
  }

  // --- 初回：ページロード時 ---
  document.addEventListener('DOMContentLoaded', () => {
    initAllProductCardLinks();

    // --- 以降：DOM 変化を監視して、追加された要素にも処理 ---
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          // 追加されたノードが Element かどうかチェック
          if (!(node instanceof Element)) return;

          // 追加されたノード自体が <product-card-link> の場合
          if (node.tagName && node.tagName.toLowerCase() === 'product-card-link') {
            initProductCardLink(node);
          }

          // 追加されたノードの子孫に <product-card-link> がいる場合
          const innerLinks = node.querySelectorAll
            ? node.querySelectorAll('product-card-link')
            : [];
          innerLinks.forEach((link) => initProductCardLink(link));
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
})();
